import { Box } from '@material-ui/core';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { EditAutocompleteButton } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/components/buttons/EditAutocompleteButton';
import { StartAutocompleteButton } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/components/buttons/StartAutocompleteButton';
import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const AddressCard = () => {
  const { temporaryCardData } = useAddressContext();
  const { palette } = useCustomTheme();

  // saved data from card is displayed instead of field to make transitions seamless
  // (thanks to setTimeout when restoring temp data in CancelChangesButton)
  const displayAddress = temporaryCardData?.address;

  if (!displayAddress) return null;

  return (
    <CustomPaper border>
      <Box mb={1}>
        <Font variant={'caption'}>
          <Text tId={'SELECTED_ADDRESS'} />
        </Font>
      </Box>
      <Box display={'flex'} alignItems={'flex-start'} gridGap={'10px'} mb={3}>
        <Icon color={palette.success.main} size={18}>
          {'check'}
        </Icon>
        <Font variant={'body2'}>
          <strong>{displayAddress}</strong>
        </Font>
      </Box>
      <Box display={'flex'} justifyContent={'flex-end'} gridGap={'8px'}>
        <StartAutocompleteButton />
        <EditAutocompleteButton />
      </Box>
    </CustomPaper>
  );
};
